import { render, staticRenderFns } from "./Footfall.vue?vue&type=template&id=7512afbc&scoped=true"
import script from "./Footfall.vue?vue&type=script&lang=js"
export * from "./Footfall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7512afbc",
  null
  
)

export default component.exports